/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusGrantBatchItem
 */
export interface BonusGrantBatchItem {
    /**
     * 批次ID
     * @type {number}
     * @memberof BonusGrantBatchItem
     */
    id?: number;
    /**
     * 所属计划ID
     * @type {number}
     * @memberof BonusGrantBatchItem
     */
    planId?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusGrantBatchItem
     */
    userId?: number;
    /**
     * 期次（从1开始）
     * @type {number}
     * @memberof BonusGrantBatchItem
     */
    batchNo?: number;
    /**
     * 本批金额
     * @type {number}
     * @memberof BonusGrantBatchItem
     */
    amount?: number;
    /**
     * 计划发放日期
     * @type {string}
     * @memberof BonusGrantBatchItem
     */
    planGrantDate?: string;
    /**
     * 状态：1-待发放，2-已完成，3-已停止
     * @type {number}
     * @memberof BonusGrantBatchItem
     */
    status?: number;
    /**
     * 状态名称
     * @type {string}
     * @memberof BonusGrantBatchItem
     */
    statusName?: string;
    /**
     * 关联流水ID（已完成时）
     * @type {number}
     * @memberof BonusGrantBatchItem
     */
    historyId?: number;
    /**
     * 实际发放时间
     * @type {string}
     * @memberof BonusGrantBatchItem
     */
    grantTime?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof BonusGrantBatchItem
     */
    createTime?: string;
}

/**
 * Check if a given object implements the BonusGrantBatchItem interface.
 */
export function instanceOfBonusGrantBatchItem(value: object): value is BonusGrantBatchItem {
    return true;
}

export function BonusGrantBatchItemFromJSON(json: any): BonusGrantBatchItem {
    return BonusGrantBatchItemFromJSONTyped(json, false);
}

export function BonusGrantBatchItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusGrantBatchItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'batchNo': json['batchNo'] == null ? undefined : json['batchNo'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'planGrantDate': json['planGrantDate'] == null ? undefined : json['planGrantDate'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'historyId': json['historyId'] == null ? undefined : json['historyId'],
        'grantTime': json['grantTime'] == null ? undefined : json['grantTime'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function BonusGrantBatchItemToJSON(json: any): BonusGrantBatchItem {
    return BonusGrantBatchItemToJSONTyped(json, false);
}

export function BonusGrantBatchItemToJSONTyped(value?: BonusGrantBatchItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'planId': value['planId'],
        'userId': value['userId'],
        'batchNo': value['batchNo'],
        'amount': value['amount'],
        'planGrantDate': value['planGrantDate'],
        'status': value['status'],
        'statusName': value['statusName'],
        'historyId': value['historyId'],
        'grantTime': value['grantTime'],
        'createTime': value['createTime'],
    };
}

